// src/utils/formatters.js

/**
 * Format a numeric value as US currency without decimals.
 *
 * Rules:
 *  - Non-numeric values return an em dash ("—").
 *  - Negative numbers are wrapped in parentheses: ($1,234)
 *  - Positive numbers are prefixed with $: $1,234
 *  - No decimals are shown.
 *
 * @param {number} val
 *   The numeric value to format.
 *
 * @returns {string}
 *   A formatted currency string or "—" for invalid inputs.
 */
export const formatCurrency = (val) => {
  if (typeof val !== "number" || !Number.isFinite(val)) return "—";

  const abs = Math.abs(val).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return val < 0 ? `($${abs})` : `$${abs}`;
};


/**
 * Format a numeric value as a percentage with two decimal places.
 *
 * Rules:
 *  - Non-numeric values return an em dash ("—").
 *  - Negative percentages are wrapped in parentheses: (2.50%)
 *  - Positive percentages appear as standard: 2.50%
 *
 * @param {number} val
 *   The numeric value to format as a percentage.
 *
 * @returns {string}
 *   A formatted percentage string or "—" for invalid inputs.
 */
export const formatPercent = (val) => {
  if (typeof val !== "number" || !Number.isFinite(val)) return "—";

  const abs = Math.abs(val).toFixed(2);
  return val < 0 ? `(${abs}%)` : `${abs}%`;
};
